
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { trigger, style, animate, transition } from '@angular/animations';

import { StandardApiError, LoginData, LoginUserInfo, SecurityQuestions, AppIdRequestorData } from '@tecommon/structures/structures';
import { HeaderEventService } from '@tecommon/ui/components/teHeader/teHeader.component';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from '@tecommon/ui/components/localStorage/localStorage.service';
import { UserInfo } from '@tecommon/structures/structures';
import { Observable } from 'rxjs';
import { GlobalErrorHandlerService } from '../../services/errorHandler/global-error-handler.service';
import { Globals } from '../../../@tecommon/ui/components/global/globals';
import { FriendlyCaptchaResponse } from '../../../@tecommon/structures/src/selfServicePortalClasses';
import { ConfigService } from '../../services/config.service';
import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk";
import { Subject } from 'rxjs';

declare var document: any;


@Component({
    selector: 'login',
    templateUrl: 'login.component.html',
    providers: [GlobalErrorHandlerService, Globals
    ],
    animations: [
        trigger('dropIn', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('500ms', style({ height: '*', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '*', opacity: .7 }),
                animate('500ms', style({ height: 0, opacity: 0 }))
            ])
        ])
    ],
    standalone: false
   
})
export class LoginComponent implements OnInit, OnDestroy {
    public user: UserInfo;
    public userId: string;
    public lastUserId: string;
    public returnUrl: string;
    public login: LoginData;
    public successMessage: string;
    public errorMessage: string;
    public signInOption: string;
    public hidePassword: boolean = true;
    public hideQuestion1: boolean = true;
    public hideQuestion2: boolean = true;
    public loggingIn: boolean = false;
    public loadingQuestions: boolean = false;
    public emailSent: boolean = false;
    public loadingEmailSentStatus: boolean = false;
    public hideEmailPasscode: boolean = true;
    public canRequestAppId: boolean;
    public loadingAppIDUserData: boolean = false;
    public requestingAppId: boolean;
    public isRequestSent: boolean;
    public _translateService: TranslateService;
    public standardError: StandardApiError;
    public btnDynamic: string = 'SignIn';
    public translateValue: any;
    public mgrEmailID: string;
    public userAccessType: string;
    public IsSignInvalid: boolean = false;

    public isAppIDReqSucess: boolean = false;

    public password = new FormControl('', [Validators.required]);
    public duoPasscode = new FormControl('', [Validators.required]);
    public question1 = new FormControl('', [Validators.required]);
    public question2 = new FormControl('', [Validators.required]);
    public emailPasscode = new FormControl('', [Validators.required]);
    public loginUserInfo: LoginUserInfo;
    public username = new FormControl('');
    public adfs = new FormControl('');

    public friendlyCaptchaToken: string;
    public isCaptchaSuccessful: boolean = false;
    public showCaptchaForExternalLogin: boolean = false;
    public friendlyCaptchaSiteKey: string = '';
    
    public friendlyCaptchaResponse: any;
  
    private inactivityTimer: any;
    private inactivityTimeout = 1* 60 * 1000; // 2 minutes
    private widgetInstance: any;
    private resendDisabled: boolean = false;
    constructor(private readonly http: HttpClient, private readonly translate: TranslateService,
        private readonly router: Router, private readonly activatedRoute: ActivatedRoute,
        private readonly headerEvents: HeaderEventService,
        private readonly localStorage: LocalStorage, private globals: Globals, private configService: ConfigService) {

        this.friendlyCaptchaSiteKey = this.configService.getApiKey();
       
       
        this.login = {} as LoginData;
        this.loginUserInfo = {} as LoginUserInfo;
        this._translateService = translate;
        this.btnDynamic = 'SignIn';
        document.language = (this.localStorage.getItem("language") === null
            || this.localStorage.getItem("language") === ""
            || this.localStorage.getItem("language") === "undefined") ? "en" : this.localStorage.getItem("language");
        this.getuserAccessType();
      
        
        this.localStorage.removeItem("firstTimeRegistration");
        this.localStorage.removeItem("myID.counter");
        
        this.localStorage.setItem("counter","0");

        console.log("counter in login:" + this.localStorage.getItem("counter"));
        this.headerEvents.languageChanged.subscribe((p) => {

            this.getSignInOptions();
            this.getQuestions();
            if (this.showCaptchaForExternalLogin) {
                this.initiateCaptcha();
            }
            
        });

        if (!this.showCaptchaForExternalLogin) {
            this.getSignInOptions();
        }

    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(
            (params: Params) => this.returnUrl = params["ReturnUrl"]);
    }

    public getuserAccessType(): any {
        this.globals.getUserInfo().subscribe(result => {
            this.userAccessType = result;
            console.log(this.userAccessType);
            
            if (this.userAccessType === "INTERNAL") {
                this.password = new FormControl('', [Validators.required, Validators.minLength(8)]);
                this.question1 = new FormControl('', [Validators.required, Validators.minLength(3)]);
                this.question2 = new FormControl('', [Validators.required, Validators.minLength(3)]);
                this.showCaptchaForExternalLogin = false; 

            } else {
                this.password = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.question1 = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.question2 = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.showCaptchaForExternalLogin = true;
                
            }
            console.log("ShowCaptcha " + this.showCaptchaForExternalLogin);
        });

    }
    public checkMinLength(): void {
        var _question1 = new String(this.question1.value);
        var _question2 = new String(this.question2.value);

        if (this.userAccessType === "INTERNAL") {
            if ((_question1.length >= 3 && _question2.length >= 3)) {
                this.IsSignInvalid = false;
            } else {
                this.IsSignInvalid = true;
            }
        }

        if (this.userAccessType !== "INTERNAL") {
            if ((_question1.length >= 1 && _question2.length >= 1)) {
                this.IsSignInvalid = false;
            } else {
                this.IsSignInvalid = true;
            }
        }

    }

    public getSignInOptions(): void {
        this.http.get<LoginData>("/api/Login/Options", { params: { culture: document.language } }).subscribe(result => {
            this.login = result;
        },
            error => {
                console.log(error.error.message);
                this.errorMessage = "ErrorLoadSignIN";
                this.loggingIn = false;
            });
    }

    public userChanged(): void {
        // Make the dropdown menu selection changed to default whenever user id is changed
        this.signInOption = null;
        //login.securityQuestions are set to NULL to stop displaying questions from previous selection before displaying the new set of questions
        this.login.securityQuestions = null;
        this.clearControls();
        
        if (!this.userId) return;
        if (!this.isCaptchaSuccessful && this.friendlyCaptchaResponse !== null && this.friendlyCaptchaResponse !== undefined ) {
            this.VerifyCaptchaResponse();
        }
        
    }

    private VerifyCaptchaResponse() {
        this.login.friendlyCaptchaToken = this.friendlyCaptchaResponse;
        this.login.userId = this.userId;
        if (this.userId) {
            this.http.post<FriendlyCaptchaResponse>('/api/Login/VerifyFriendlyCaptcha', this.login).subscribe(result => {
                
                this.isCaptchaSuccessful = result.success;
                console.log("isCaptchaSuccessful:" + this.isCaptchaSuccessful);
                if (!this.isCaptchaSuccessful) {
                    console.log(" Friendly Captcha  Api Verification returned false as the response");
                    this.errorMessage = "CaptchaError";
                    this.loggingIn = false;
                }
                
            },
                error => {
                    var _error = error.error.standardApiError;
                    if (_error.name == "INVALID_AUTHENTICATION") {
                        this.errorMessage = "NetworkFailureMsg";
                    } else {
                        console.log(error.error.message + " Friendly Captcha Error in VerifyCaptchaResponse");
                        this.errorMessage = "CaptchaError";
                        this.loggingIn = false;
                    }
                    this.http.get('/api/Login/ApplicationErrorNotification', {
                        params: {
                            errormessage: 'client-side error: Friendly Captcha Error in VerifyCaptchaResponse:' + error.status
                                + ' , message:' + error.message + ' , Url:' + error.url
                                + ' , headers:' + error.headers
                                + ' , StatusText:' + error.statusText
                                + ' , Error:' + error.error
                                + ' , ErrorInfo:' + error.toString()
                        }, responseType: 'text'
                    }).subscribe(result => {
                        
                    });
                });
        }
    }

    public getQuestions(): void {
        this.successMessage = this.errorMessage = null;
        this.btnDynamic = 'SignIn';
        if (!this.userId) return;
        this.loadingQuestions = true;
        this.http.get<SecurityQuestions[]>('/api/Login/' + this.userId + '/' + document.language + '/Questions').subscribe(result => {
            this.login.securityQuestions = result;
            this.loadingQuestions = false;
        },
            error => {
                var _error = error.error;
                if (_error.name === 'NOT_REGISTERED_SECURITY_QA') {
                    this.errorMessage = 'NotRegisteredSecurityQA_I';
                } else if (_error.name === 'INVALID_USER') {
                    this.errorMessage = "InvalidUser";
                } else {
                    this.errorMessage = "SecurityFailureMsg";
                }
                this.loadingQuestions = false;
                this.login.securityQuestions = null;
                console.log(error);
            });
    }

    public clearControls(): void {
        this.errorMessage = null;
        this.successMessage = null;
        this.password.reset('');
        this.question1.reset('');
        this.question2.reset('');
        this.duoPasscode.reset('');
        this.emailPasscode.reset('');
        this.loggingIn = false;
        this.canRequestAppId = false;
        this.loadingAppIDUserData = false;
        this.requestingAppId = false;
        this.loadingQuestions = false;
        this.emailSent = false;
        this.loadingEmailSentStatus = false;
        this.btnDynamic = 'SignIn';
        this.isAppIDReqSucess = false;
    }

    public cancel(): void {
        this.clearControls();
        // Make the dropdown menu selection changed to default whenever user id is changed
        this.signInOption = null;
    }

    public close(): void {
        this.userId = '';
        //this.username.setValue('');
        this.username.reset();
        this.clearControls();
        // Make the dropdown menu selection changed to default whenever user id is changed
        this.signInOption = null;
    }

    public optionChanged(): void {
        //login.securityQuestions are set to NULL to stop displaying questions from previous selection before displaying the new set of questions
        this.login.securityQuestions = null;
        this.clearControls();
        
        if (this.signInOption === 'external_email') {
            this.sendNewEmail();
        }

        if (this.signInOption === 'questions') {
            this.getQuestions();
        }
       
        this.successMessage = null;
    }

    public sendNewEmail(): void {
        if (!this.userId) return;

        if (this.resendDisabled) {
            return;
        }

        this.resendDisabled = true;

        setTimeout(() => {
            this.resendDisabled = false;
        }, 60000);

        this.successMessage = this.errorMessage = null;
        this.loadingEmailSentStatus = true;
        try {
            this.http.get<boolean>('/api/Login/SendEmailPasscode/' + this.userId + "/" + document.language).subscribe(
                result => {
                    this.loadingEmailSentStatus = false;
                    //this.emailSent = result === "true" ? true : false;
                    this.emailSent = result as boolean;
                    if (!this.emailSent) {
                        this.errorMessage = 'FatalErrorMsg';
                        this.successMessage = null;
                    }
                },
                error => {
                    this.loadingEmailSentStatus = false;
                    this.emailSent = false;
                    this.errorMessage = 'FatalErrorMsg';
                    this.successMessage = null;
                    console.log(error.error.message);
                });
        }
        catch (e) {
            console.log("External Email Authetication - Send Identification Code is NOT working:" + e);
            this.loadingEmailSentStatus = false;
            this.errorMessage = 'FatalErrorMsg';
            this.successMessage = null;
        }
    }

    public initiateCaptcha(): void {
        try {
            if (this.showCaptchaForExternalLogin && this.userId != null) {
                console.log("Entered");
                if (!this.widgetInstance) {
                    console.log("Entered 2");
                    const sdk = new FriendlyCaptchaSDK();

                    const mount = document.querySelector("#captchaDiv");

                    // Create the widget
                    this.widgetInstance = sdk.createWidget({
                        element: mount,
                        sitekey: this.friendlyCaptchaSiteKey,
                        language: document.language,
                    });
                    this.setupInactivityTracking();
                }
            }
            //else {
            //    if (this.widgetInstance) {
            //        console.log("Destory getting called");
            //        this.widgetInstance.destory()
            //        console.log("Destory getting called 2");
            //        this.clearInactivityTimer();
            //        this.removeInactivityListeners();
            //    }
            //}
        }
        catch (e) {
            console.log("Friendly Captcha is NOT working(initiateCaptcha): " + e);
            this.errorMessage = 'CaptchaError';
            this.loggingIn = false;
            this.http.get('/api/Login/ApplicationErrorNotification', {
                params: {
                    errormessage: 'client-side error: Friendly Captcha is NOT working(initiateCaptcha):' + e.status
                        + ' , message:' + e.message + ' , Url:' + e.url
                        + ' , headers:' + e.headers
                        + ' , StatusText:' + e.statusText
                        + ' , Error:' + e.error
                        + ' , ErrorInfo:' + e.toString()
                }, responseType: 'text'
            }).subscribe(result => {
               
            });
        }
    }

    public onUserIdChange(newValue: string): void {
        const captchaHolder = document.querySelector("#captchaHolderDiv");
        if (!newValue) {
            // Hide Captcha if UserID is empty
            if (this.widgetInstance) {
                console.log("Reset getting called");
                
                if (captchaHolder) {
                    captchaHolder.style.display = "none";
                }
                this.widgetInstance.destory();
                this.clearInactivityTimer();
                this.removeInactivityListeners();
                //document.getElementById("captchaHolderDiv").display = "";
                //this.widgetInstance.reset();
                //this.widgetInstance = null;
                
            }
            this.isCaptchaSuccessful = false;
            this.friendlyCaptchaResponse = null;
            return;
        }
        if (newValue !== this.lastUserId) {
            this.lastUserId = newValue;
            captchaHolder.style.display = "block";
            this.initiateCaptcha();
        }
    }
    ngAfterViewInit() {

        try {
           
           // setTimeout(() => this.initiateCaptcha(), 1000);

            window.addEventListener('frc:widget.complete', (event: any) => {

                this.friendlyCaptchaResponse = event.detail.response;
                this.VerifyCaptchaResponse();
            });

        } catch (e) {
            console.log("Friendly Captcha is NOT working(ngAfterViewInit): " + e);
            this.errorMessage = "CaptchaError";
            this.loggingIn = false;
            this.http.get('/api/Login/ApplicationErrorNotification', {
                params: {
                    errormessage: 'client-side error: Friendly Captcha is NOT working(ngAfterViewInit):' + e.status
                        + ' , message:' + e.message + ' , Url:' + e.url
                        + ' , headers:' + e.headers
                        + ' , StatusText:' + e.statusText
                        + ' , Error:' + e.error
                        + ' , ErrorInfo:' + e.toString()
                }, responseType: 'text'
            }).subscribe(result => {
                
            });
        }
    }


    //onUserInputChanged() {
    //    this.initiateCaptcha();
    //}

    ngOnDestroy() {
        this.clearInactivityTimer();
        this.removeInactivityListeners();
    }

    setupInactivityTracking() {
        this.resetInactivityTimer();
        window.addEventListener('mousemove', this.resetInactivityTimerBound, true);
        window.addEventListener('keydown', this.resetInactivityTimerBound, true);
        window.addEventListener('mousedown', this.resetInactivityTimerBound, true);
        window.addEventListener('touchstart', this.resetInactivityTimerBound, true);
    }

    removeInactivityListeners() {
        window.removeEventListener('mousemove', this.resetInactivityTimerBound, true);
        window.removeEventListener('keydown', this.resetInactivityTimerBound, true);
        window.removeEventListener('mousedown', this.resetInactivityTimerBound, true);
        window.removeEventListener('touchstart', this.resetInactivityTimerBound, true);
    }

    private resetInactivityTimerBound = () => this.resetInactivityTimer();

    private resetInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityTimer = setTimeout(() => {
            this.resetCaptchaWidget();
        }, this.inactivityTimeout);
    }

    private clearInactivityTimer() {
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    }

    private resetCaptchaWidget() {

        if (this.widgetInstance) {
            if (this.isCaptchaSuccessful) {
                this.isCaptchaSuccessful = false;
                this.widgetInstance.reset();
                this.errorMessage = "CaptchaExpiredRetry";
            }

        }

    }

    public submitLogin(): void {
        
        this.successMessage = this.errorMessage = this.standardError = null;
        this.localStorage.setItem("hasUserLoggedInUsingAzureMfa", "false");
        if (this.loggingIn) return;  // Don't allow another login attempt while one is already happening.
        this.loggingIn = true;
       
        // clear entries for new login attempt.
        this.login.password = this.login.mfaPasscode = this.login.securityAnswer1 = this.login.securityAnswer2 = this.login.appIdRequestorData = null;
        switch (this.signInOption) {
            case 'password':
                this.login.password = this.password.value;
                break;
            case 'questions':
                if (this.login.securityQuestions) {
                    this.login.securityAnswer1 = this.question1.value;
                    this.login.securityAnswer2 = this.question2.value;
                    this.login.securityQuestionId1 = this.login.securityQuestions[0].securityQuestionId;
                    this.login.securityQuestionId2 = this.login.securityQuestions[1].securityQuestionId;
                    break;
                }
            case 'external_email':
                this.login.externalEmailIdCode = this.emailPasscode.value;
                break;
         
        }
        this.login.culture = document.language;
        this.http.post<StandardApiError>("/api/Login/" + this.userId, this.login).subscribe(result => {
            this.localStorage.removeItem("firstTimeRegistration");
            try {
                if (this.login.needsTwoFactorAuth) {
                    if (this.returnUrl)
                        this.router.navigateByUrl('/LoginSecondFactor?returnUrl=' + this.returnUrl);
                    else
                        this.router.navigateByUrl('/LoginSecondFactor');
                    return;
                }
                // we could check to see if there was a return URL provided, if not, go to /Main/Home
                if (this.returnUrl && !this.returnUrl.endsWith("Main/ADMAccounts") && !this.returnUrl.startsWith("/Main/UnlockAccount/")) {

                    this.standardError = result;

                    if (this.standardError.name == "lockstatus" && this.standardError.message == "true") {
                        window.location.replace("/Main/UnlockAccount");
                    } else {

                        if (this.standardError.needsLoadModel != "") {
                            this.localStorage.setItem("firstTimeRegistration", this.standardError.needsLoadModel);
                        }
                        window.location.replace(this.returnUrl);                  
                    }
                }
                else {

                    this.standardError = result;
                    if (this.standardError.name == "lockstatus" && this.standardError.message == "true") {
                        window.location.replace("/Main/UnlockAccount");
                    } else {
                        if (this.standardError.needsLoadModel != "") {
                            this.localStorage.setItem("firstTimeRegistration", this.standardError.needsLoadModel);
                        }
                        window.location.replace("/Main/Home");
                    }
                }

            } catch (e) {
                console.log("window.location.replace is not working: " + e);
                this.errorMessage = "FatalErrorMsg";
                this.btnDynamic = 'SignIn';
                this.loggingIn = false;
            }

        },
            error => {
                //console.log(error.error);
                this.loggingIn = false;
                var _error = error.error;
                console.log('SignIn Option : ' + this.signInOption);
                console.log(error.error);
                this.localStorage.removeItem("firstTimeRegistration");
                this.btnDynamic = 'SignIn';
               
                switch (this.signInOption) {
                    case 'password':

                        if (_error.userAccessType === "EXTERNAL") {
                            this.errorMessage = 'NetworkFailureMsg';
                        } else if (_error.name === 'NOT_ACTIVE_USER') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'INVALID_CREDENTIALS') {
                            this.errorMessage = 'InvalidCredentials_I';
                        } else if (_error.name === 'USER_NOT_IN_AD_LDS') {
                            this.errorMessage = 'UserdoesNOTexistInADandLDS_I';
                        } else if (_error.name === 'NO_SECURITY_STATUS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'NOT_VALID_SECURITY_STATUS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_IN_PERCALL_OU') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_IN_PERCALL_OU_LDS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_DISABLED_IN_AD') {
                            this.errorMessage = 'UserDisabledInAD_I';
                        } else if (_error.name === 'USER_LOCKED_IN_AD') {
                            this.errorMessage = 'UserLockedInAD_I';
                        } else if (_error.name === 'INCORRECT_USER_ID_OR_CREDENCIAL') {
                            this.errorMessage = 'InvalidCredentials_I';
                        } else if (_error.name === 'INVALID_USER') {
                            this.errorMessage = "InvalidUser";
                        } else {
                            this.errorMessage = 'NetworkFailureMsg';
                        }

                        this.password.setValue('');
                        this.password.markAsDirty();
                        this.password.markAsTouched();
                        break;
                    case 'duo':
                        if (_error.name === 'INCORRECT_USER_ID_OR_CREDENCIAL') {
                            this.errorMessage = 'NetworkFailureMsg';//default
                        }
                        else if (_error.name === 'DUO_FAILED') {
                            this.errorMessage = 'DuoFailureMsg';//default
                        } else if (_error.name === 'INVALID_AUTHENTICATION') {
                            this.errorMessage = 'NetworkFailureMsg';//default
                        } else {
                            this.errorMessage = 'DuoFailureMsg';
                        }
                        this.duoPasscode.setValue('');
                        this.duoPasscode.markAsDirty();
                        this.duoPasscode.markAsTouched();
                        break;
                    case 'questions':

                        if (_error.userAccessType === "EXTERNAL") {
                            this.errorMessage = 'SecurityFailureMsg';
                        } else if (_error.name === 'NOT_REGISTERED_SECURITY_QA') {
                                this.errorMessage = 'NotRegisteredSecurityQA_I';
                        } else if (_error.name === 'AD_AND_CSS_CHECKS_SECURITY_QA') {
                                this.errorMessage = 'UserDisabledInADAndOtherThanActive_I';
                        } else if (_error.name === 'INCORRECT_ANSWER_SECURITY_QA') {
                                this.errorMessage = 'WrongAnswerProvidedSecurityQA_I';
                        } else if (_error.name === 'INCORRECT_ANSWER_SECURITY_QA_WITHIN_30MIN') {
                                this.errorMessage = 'WrongAnswerFailed6AttemptIn30Min_I';
                        } else if (_error.name === 'SECURITY_QA_FAILURE') {
                                this.errorMessage = 'SecurityFailureMsg';
                        } else if (_error.name === 'NOT_ACTIVE_USER') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_NOT_IN_AD_LDS') {
                            this.errorMessage = 'UserdoesNOTexistInADandLDS_I';
                        } else if (_error.name === 'NO_SECURITY_STATUS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'NOT_VALID_SECURITY_STATUS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_IN_PERCALL_OU') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_IN_PERCALL_OU_LDS') {
                            this.errorMessage = 'UserInADInvalidSecurityStatus_I';
                        } else if (_error.name === 'USER_DISABLED_IN_AD') {
                            this.errorMessage = 'UserDisabledInAD_I';
                        } else if (_error.name === 'INVALID_USER') {
                            this.errorMessage = "InvalidUser";
                        } else {
                            this.errorMessage = 'SecurityFailureMsg';//default
                        }

                        this.question1.setValue('');
                        this.question1.markAsDirty();
                        this.question1.markAsTouched();
                        this.question2.setValue('');
                        this.question2.markAsDirty();
                        this.question2.markAsTouched();
                        break;
                    case 'external_email':
                        if (_error.name === 'NOT_REGISTERED_EMAIL' || _error.name === 'OTP_ENTERED_AFTER_30MIN') {
                            this.errorMessage = 'ExtInvalidOTP';
                        }
                        else if (_error.name === 'EXCEPTION' || _error.name === 'INCORRECT_USER_ID_OR_CREDENCIAL') {
                            this.errorMessage = 'NetworkFailureMsg';
                        } else if (_error.name === 'INVALID_OTP') {
                            this.errorMessage = 'ExtInvalidOTP';
                        } else if (_error.name === 'INVALID_AUTHENTICATION') {
                            this.errorMessage = 'NetworkFailureMsg';
                        } else if (_error.name === 'INVALID_USER') {
                            this.errorMessage = "InvalidUser";
                        }
                        else {
                            this.errorMessage = 'NetworkFailureMsg';//default
                        }
                        this.emailPasscode.setValue('');
                        this.emailPasscode.markAsDirty();
                        this.emailPasscode.markAsTouched();
                        break;
                }

            });
    }

    public next(): void {
        this.showCaptchaForExternalLogin = false;
        this.errorMessage = null;
        this.clearInactivityTimer();
        this.removeInactivityListeners();
        this.getSignInOptions();
    }



   
}